/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../resources/resources.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />
/// <reference path="../positioning/positioning.ts" />

namespace Teva {
    interface SelectBoxOptions {
        QueryMethod?: SelectBoxQueryInterface;
        PlaceHolderText?: any;
        AllowManualValues?: boolean;
        AllowClear?: boolean;
        AllowSearch?: boolean;
        Enabled?: boolean;
        EnabledMethod?: any;
        EnableCaching?: boolean;
        EnableCachingPartialReduce?: boolean;
        FormatResultItem?: any;
        MinimumLength?: number;
        Inline?: boolean;
        OnChange?: SelectBoxOnChangeInterface;
        OnRefreshResultsData?: any;
        SupportHTML?: boolean;
        EmptyItemContents?: any;
        EmptyItemClick?: any;
        EmptyItemAlwaysVisible?: boolean;
        AlternateShowMethod?: any;
        ContainerCssClasses?: string;
        CtrlClickEvent?: any;
        SelectFirstOnClose?: any;
        SelectOnTab?: boolean;
        EmptyValue?: string;
        ThrottleTimeout?: number;
        FixedPosition?: boolean;
        CustomEnterKeyEvent?: any;
        FooterCreateText?: string;
        FooterCreate?: any;
    }

    interface SelectBoxQueryInterface {
        (Terms: string, QueryByID: any, PageIndex: number, Callback: any): void;
    }

    interface SelectBoxOnChangeInterface {
        (Value: string, Text: string, Data: any, Instance: SelectBox, ClearValue?: boolean): void;
    }

    export class SelectBox {
        static Enable($Selector, Options: SelectBoxOptions) {
            var OptionsExtended = false;
            $Selector.each(function () {
                var Input = $(this);
                if (Input.data("SelectBox") != null)
                    return Input.data("SelectBox");
                if (!OptionsExtended) {
                    Options = $.extend({}, SelectBox.GetDefaults(), Options);
                    OptionsExtended = true;
                }

                new SelectBox(Input, Options);
            });
        }
        static GetInstance($Input: JQuery): SelectBox {
            return $Input.data("SelectBox");
        }

        private static GetDefaults(): SelectBoxOptions {
            return <SelectBoxOptions>{
                QueryMethod: null,
                PlaceHolderText: "",
                AllowManualValues: false,
                AllowClear: true,
                AllowSearch: true,
                Enabled: true,
                EnableCaching: true,
                EnableCachingPartialReduce: true,
                FormatResultItem: null,
                MinimumLength: null,
                Inline: false,
                OnChange: null,
                SupportHTML: false,
                SelectFirstOnClose: false,
                SelectOnTab: true,
                EmptyItemAlwaysVisible: false,
                EmptyValue: "",
                ThrottleTimeout: 250,
                FixedPosition: false
            };
        }

        constructor($Input, Options: SelectBoxOptions) {
            var Instance = this;
            $Input.data("SelectBox", this);

            Instance.$Input = $Input;
            Instance.Input = $Input[0];
            Instance.Options = Options;
            Instance.QueryMethod = Options.QueryMethod;
            Instance.ContainerCssClasses = Options.ContainerCssClasses;
            Instance.OnChange = Options.OnChange;

            if (Instance.QueryMethod == null && Instance.Input.tagName == "SELECT")
                Instance.ConvertFromSelect();

            Instance.CreateElements();
            if (!Options.Enabled || $Input.attr("readonly") == "readonly" || (Options.EnabledMethod && !Options.EnabledMethod(Instance)))
                Instance.Disable();
        }

        public ClearCache(): void {
            this.HideResults();
            this.DisableScroll();
            this.Cache = null;
            this.VisibleTerms = null;
            this.VisiblePageIndex = null;
        }
        public HideResults(Focus = false, PopState = true) {
            var Instance = this;
            if (!Instance.PrimaryContainer.hasClass("teva-selectbox-container-open"))
                return;

            if (PopState && document.body.hasClass("teva-selectbox-mobile") && history.state != null && history.state.SelectBox)
                window.history.back();

            if (Focus && !document.body.hasClass("teva-selectbox-mobile"))
                Instance.$Label.trigger("focus");
            Instance.VisibleTerms = null;
            Instance.$SearchContainer.stop().fadeOut(50, function () {
                Instance.Container.appendChild(Instance.SearchContainer);
                Instance.PrimaryContainer.removeClass("teva-selectbox-container-open");
                if (document.body.hasClass("teva-selectbox-mobile")) {
                    Instance.$Clone.remove();
                    Instance.$Clone = null;
                    Instance.$PrimaryContainer.insertBefore(Instance.Input);
                    document.body.removeClass("teva-selectbox-mobile");
                }
                if (Instance.Options.AllowSearch)
                    Instance.$SearchTermsInput.val("");
            });
            Instance.$Container
                .closest(".sumit-field-active")
                .removeClass("sumit-field-active")
                .toggleClass("sumit-field-populated", Instance.SelectedText != null && Instance.SelectedText.length > 0);
            $(document).off("click.SelectBox");
            Instance.$Container.parents().off("scroll.SelectBox");
            $(window).off("scroll.SelectBox, resize.SelectBox");
        }

        private PositionResults(IsMobile) {
            var Instance = this;
            if (IsMobile) {
                Instance.$SearchContainer
                    .css("top", "")
                    .css("left", "");
                return;
            }

            if (Instance.Options.FixedPosition) {
                Instance.$SearchContainer.css("position", "fixed").show();
            }
            else {
                if (!Instance.$SearchContainer.parent().is("body"))
                    document.body.appendChild(Instance.SearchContainer);
            }


            var Offset = Instance.$Label.offset();
            var Top = Offset.top;
            //Top = (Top - Instance.$Label.height()) * 0.9 + $(window).scrollTop() * (1 - 0.9);
            //if (window.outerWidth >= 850 && window.outerWidth <= 1500 && window.devicePixelRatio >= 1.4)
            //Top = Top + $(window).scrollTop() * (1 / 0.9 - 1);

            if (!(Instance.Options.Inline || Instance.Options.AllowSearch))
                Top += Instance.$Label.outerHeight();
            if (Instance.Options.FixedPosition)
                Top -= window.pageYOffset;

            var Left;
            if (document.body.dir == "rtl") {
                Left = Offset.left + Instance.$Label.outerWidth() - Instance.$SearchContainer.outerWidth();
                if (Left < 0)
                    Left = Offset.left;
            }
            else
                Left = Offset.left;

            var ClosestModal = Instance.$Label.closest(".modal");
            if (ClosestModal.length > 0 && ClosestModal.css("z-index"))
                Instance.$SearchContainer.css("z-index", Number(ClosestModal.css("z-index")) + 1);

            Instance.$SearchContainer
                .css("top", Top + "px")
                .css("left", Left + "px");
        }
        public ShowResults(Terms = null) {
            var Instance = this;

            var IsMobile = window.innerWidth < 640;
            if (!IsMobile) {
                var $Modal = Instance.$Label.closest('.modal');
                if ($Modal.length > 0) {
                    var ModalBody = $Modal.find(".modal-body")[0];
                    //console.log({
                    //    WindowInnerHeight: window.innerHeight,
                    //    ModalBodyScrollHeight: ModalBody.scrollHeight,
                    //    LabelOffsetTop: Instance.$Label.offset().top,
                    //    ModalBodyScrollTop: ModalBody.scrollTop,
                    //    WindowScrollY: window.scrollY,
                    //    Difference: Math.max(window.innerHeight, ModalBody.scrollHeight) - Instance.$Label.offset().top - ModalBody.scrollTop,
                    //    Difference2: window.innerHeight - (Instance.$Label.offset().top - window.scrollY)
                    //});
                    if (Math.max(window.innerHeight, ModalBody.scrollHeight) - Instance.$Label.offset().top - ModalBody.scrollTop < 356
                        && window.innerHeight - (Instance.$Label.offset().top - window.scrollY) < 356)
                        IsMobile = true;
                }
                else {
                    if (document.body.scrollHeight - Instance.$Label.offset().top < 356)
                        IsMobile = true;
                }
            }
            if (IsMobile) {
                document.body
                    .addClass("teva-selectbox-mobile")
                    .appendChild(Instance.PrimaryContainer);
                Instance.$Clone = Instance.$PrimaryContainer.clone().insertBefore(Instance.Input);
                history.pushState({ SelectBox: true, SelectBoxID: SelectBox.NextID++ }, "");
                SelectBox.VisibleMobileInstance = Instance;
            }
            Instance.PrimaryContainer.addClass("teva-selectbox-container-open");
            Instance.PositionResults(IsMobile);
            Instance.$Container.closest(".sumit-field").addClass("sumit-field-active");
            Instance.$Container.parents().off("scroll.SelectBox").on("scroll.SelectBox", function () {
                Instance.PositionResults(IsMobile);
            });
            $(window).on("scroll.SelectBox, resize.SelectBox", function () {
                Instance.PositionResults(IsMobile);
            });
            $(document).on("click.SelectBox", function (Event) {
                if ($(Event.target).closest(Instance.SearchContainer).length != 0)
                    return;

                var SelectFirstOnClose;
                if (typeof (Instance.Options.SelectFirstOnClose) == "boolean")
                    SelectFirstOnClose = Instance.Options.SelectFirstOnClose;
                else
                    Instance.Options.SelectFirstOnClose = Instance.Options.SelectFirstOnClose();

                if (SelectFirstOnClose && Instance.$SearchTermsInput != null && Instance.$SearchTermsInput.val().length > 0)
                    Instance.Keyup_Results("Enter", false);
                else if (Instance.$SearchTermsInput != null && Instance.$SearchTermsInput.val().length == 0 && Instance.SelectedText != "") {
                    Instance.ClearValue();
                    Instance.HideResults();
                }
                else
                    Instance.HideResults();
            });
            Instance.$SearchContainer.css("z-index", Teva.Positioning.GetNextZIndex()).fadeIn(200);
            if (Instance.Options.AllowSearch) {
                if (window.innerWidth >= 640)
                    Instance.$SearchTermsInput.trigger("focus");
                if (Terms == null && Instance.SelectedValue != null && Instance.SelectedValue != Instance.Options.EmptyValue) {
                    Instance.$SearchTermsInput.val(Instance.SelectedText == null ? "" : Instance.SelectedText);
                    Instance.SearchTermsInput.select();
                }
                else
                    Instance.$SearchTermsInput.val(Terms);
            }
            if (!IsMobile) {
                if (Instance.$Container.offset().top + 200 > $(window).scrollTop() + $(window).height()) {
                    $('html, body').animate({
                        scrollTop: Instance.$Container.offset().top - ($(".og-topbar").length == 0 ? 0 : $(".og-topbar").height()) - ($(".og-navigation-bar").length == 0 ? 0 : $(".og-navigation-bar").height()) - 10
                    });
                }
            }
            Instance.RefreshResults(Terms == null ? "" : Terms);
        }
        public Toggle(Enabled) {
            if (Enabled)
                this.Enable();
            else
                this.Disable();
        }
        public Enable() {
            this.Container.removeClass("teva-selectbox-disabled");
            this.Disabled = false;
        }
        public Disable() {
            this.Container.addClass("teva-selectbox-disabled");
            this.Disabled = true;
        }
        private IsDisabled(): boolean {
            return this.Disabled;
        }
        private SetTextHTML(Element, Text, Data?): void {
            if (this.Options.SupportHTML)
                Element.innerHTML = Text;
            else {
                if (Data != null && Data.html != null)
                    Element.innerHTML = Data.html;
                else
                    Element.innerText = Text;
                Element.setAttribute("title", Text);
            }
        }
        public SetValueFromQueryMethod(Value): void {
            var Instance = this;
            Instance.QueryMethod("", Value, 0, function (Data) {
                for (var i = 0; i < Data.results.length; i++) {
                    var Result = Data.results[i];
                    if (Result.id == Value) {
                        Instance.SetValue(Result.id, Result.text, Result.data, false);
                        return;
                    }
                    if (Result.children) {
                        for (var j = 0; j < Result.children.length; j++) {
                            var Child = Result.children[j];
                            if (Child.id == Value) {
                                Instance.SetValue(Child.id, Child.text, Child.data, false);
                                return
                            }
                        }
                    }
                }
            });
        }
        public SetValue(Value, Text, Data = null, IsClearValue = false, ForceChangedEvent = false): void {
            var Instance = this;
            var ValueChanged = ForceChangedEvent
                || Instance.$Input.val() != Value
                || (Instance.SelectedText != Text && !(Instance.SelectedText == null && Text == ""));
            Instance.$Input
                .val(Value)
                .attr("data-text", Text);
            Instance.SetTextHTML(Instance.LabelText, Text, Data);

            Instance.PreviousValue = Instance.SelectedValue;
            Instance.PreviousText = Instance.SelectedText;
            Instance.SelectedValue = Value;
            Instance.SelectedText = Text;
            Instance.SelectedData = Data;
            Instance.ChangeEventFromInit = false;
            if (ValueChanged) {
                Instance.$Input.trigger("change");
                Instance.$LabelText.toggleClass("teva-selectbox-label-text-placeholder", IsClearValue);
                if (Instance.OnChange != null)
                    Instance.OnChange(Value, Text, Data, Instance, IsClearValue);
            }
        }
        public SetData(Data = null, IsInit: boolean = false): void {
            var Instance = this;
            Instance.SelectedData = Data;
            Instance.ChangeEventFromInit = IsInit;
            var $Form = Instance.$Input.closest('form');
            var FormModifiedState = $Form.data("og-modified");
            Instance.$Input.trigger("change");
            if (Instance.OnChange != null)
                Instance.OnChange(Instance.SelectedValue, Instance.SelectedText, Data, Instance, false);
            $Form.data("og-modified", FormModifiedState);
        }

        public ClearValue(): void {
            this.SetValue(this.Options.EmptyValue, this.GetPlaceholderText(), null, true);
            this.$SearchResultsContainer.find(".teva-selectbox-search-results-result-hover").removeClass("teva-selectbox-search-results-result-hover");
            this.$SearchResultsContainer.find(".teva-selectbox-search-results-result-active").removeClass("teva-selectbox-search-results-result-active");
        }
        private GetPlaceholderText() {
            if (this.Options.PlaceHolderText == null)
                return;
            if (typeof (this.Options.PlaceHolderText) == "string")
                return this.Options.PlaceHolderText;
            else
                return this.Options.PlaceHolderText(this);
        }

        private ConvertFromSelect(): void {
            var Instance = this;
            Instance.$Input.addClass("teva-selectbox-simple");
            Instance.Options = $.extend({}, Instance.Options);
            Instance.Options.AllowSearch = Instance.Input.hasClass("teva-selectbox-container-allowsearch");
            if (Instance.Options.AllowSearch)
                Instance.Input.removeClass("teva-selectbox-container-allowsearch");
            if (Instance.$Input.data("supporthtml") == "1") {
                Instance.Options.SupportHTML = true;
                Instance.Options.AllowSearch = false;
            }
            if (Instance.ContainerCssClasses == null)
                Instance.ContainerCssClasses = Instance.Input.className;
            if (Instance.$Input.prop("disabled"))
                Instance.Disabled = true;

            if (Instance.$Input.data("changeevent"))
                Instance.OnChange = eval(Instance.$Input.data("changeevent"));
            Instance.SelectConvertedResults = Instance.GetQueryFromSelect(Instance.$Input);
            if (Instance.Options.EnableCaching) {
                if (Instance.Cache == null)
                    Instance.Cache = [];
                Instance.Cache["////0"] = { results: Instance.SelectConvertedResults };
            }
            Instance.QueryMethod = function (Terms, QueryByID, PageIndex, Callback) {
                Callback({ results: Instance.SelectConvertedResults });
            };

            var $NewInput = $
                (document.createElement('input')
                    .attr("type", "hidden")
                    .attr("name", Instance.Input.getAttribute("name"))
                    .attr("id", Instance.Input.getAttribute("id"))
                    .addClass("teva-selectbox-hiddeninput"))
                .addClass(Instance.Input.className)
                .data("SelectBox", Instance)
                .attr("onchange", Instance.Input.getAttribute("onchange"))
                .attr("placeholder", Instance.Input.getAttribute("placeholder"))
                .attr("data-val", Instance.Input.getAttribute("data-val"))
                .attr("data-msg-required", Instance.Input.getAttribute("data-msg-required"))
                .insertAfter(Instance.Input);

            if (Instance.Input.getAttribute("data-originalvalue"))
                $NewInput.attr("data-originalvalue", Instance.Input.getAttribute("data-originalvalue"));

            if (Instance.Input.getAttribute("data-val")) {
                var $Form = Instance.$Input.closest("form");
                $Form.removeData('validator');
                $Form.removeData("unobtrusiveValidation");
                (<any>$).validator.unobtrusive.parse($Form);
            }

            Instance.$Input.copyEventTo("change", $NewInput);

            var Selected = Instance.$Input.find("option:selected");
            if (Selected.length > 0) {
                $NewInput
                    .val(Selected.val())
                    .attr("data-text", Instance.Options.SupportHTML && Selected.data("html") ? Selected.data("html") : Selected[0].innerText);
            }
            Instance.$Input.remove();
            Instance.$Input = $NewInput;
            Instance.Input = $NewInput[0];
        }
        private GetQueryFromSelect($Container) {
            var Instance = this;
            var ToReturn = new Array();
            $Container.find("> *").each(function () {
                var $this = $(this);
                if (this.tagName == "OPTION") {
                    ToReturn.push({
                        id: (<any>this).value,
                        text: Instance.Options.SupportHTML && $this.data("html") ? $this.data("html") : this.innerText,
                        cssClass: this.className,
                        data: $this.data(),
                        disabled: this.getAttribute("disabled") == "disabled"
                    });
                }
                else if (this.tagName == "OPTGROUP") {
                    ToReturn.push({
                        text: this.getAttribute("label"),
                        cssClass: this.className,
                        children: Instance.GetQueryFromSelect($this),
                        data: $this.data()
                    });
                }
            });
            return ToReturn;
        }
        private CreateElements(): void {
            var Instance = this;
            Instance.Input.setAttribute("type", "hidden");
            Instance.PrimaryContainer = document.createElement('div')
                .addClass("teva-selectbox-container");
            if (Instance.Input.hasClass("input-col-2"))
                Instance.PrimaryContainer.addClass("input-col-2");
            if (Instance.Input.hasClass("teva-selectbox-simple"))
                Instance.PrimaryContainer.addClass("teva-selectbox-simple");
            Instance.$PrimaryContainer = $(Instance.PrimaryContainer)
                .addClass(Instance.ContainerCssClasses)
                .addClass(Instance.$Input.data("containerclass"))
                .data("SelectBox", Instance);

            Instance.Container = document.createElement('div');
            Instance.$Container = $(Instance.Container);

            Instance.Container.addClass("teva-selectbox");
            if (Instance.Disabled)
                Instance.Container.addClass("teva-selectbox-disabled");
            if (Instance.Options.Inline || Instance.Options.AllowSearch)
                Instance.Container.addClass("teva-selectbox-inline");
            Instance.PrimaryContainer.appendChild(Instance.Container);

            Instance.Label = document.createElement('a');
            Instance.$Label = $(Instance.Label);
            Instance.Label.href = "#";
            Instance.Label.addClass("teva-selectbox-label");
            Instance.Container.appendChild(Instance.Label);

            Instance.LabelText = document.createElement('div');
            Instance.$LabelText = $(Instance.LabelText);

            Instance.LabelText.addClass("teva-selectbox-label-text");
            Instance.Label.appendChild(Instance.LabelText);

            //Instance.$Label.attr("onclick", "return false;");

            var InputValue = Instance.$Input.val();
            if (InputValue != null && (InputValue != "" || (Instance.$Input.attr("data-text") != null && Instance.$Input.attr("data-text") != ''))) {
                Instance.PreviousValue = Instance.SelectedValue;
                Instance.PreviousText = Instance.SelectedText;
                Instance.SelectedValue = InputValue;
                if (Instance.$Input.attr("data-text") != null) {
                    Instance.SetTextHTML(Instance.LabelText, Instance.$Input.attr("data-text"));
                    Instance.SelectedText = Instance.$Input.attr("data-text");
                }
                else {
                    Instance.SetTextHTML(Instance.LabelText, InputValue);
                    Instance.SelectedText = InputValue;
                }
            }
            else
                Instance.SetTextHTML(Instance.LabelText, Instance.GetPlaceholderText());
            if (Instance.SelectedValue == null || Instance.SelectedValue == "" || Instance.SelectedValue == Instance.Options.EmptyValue)
                Instance.LabelText.addClass("teva-selectbox-label-text-placeholder");

            Instance.SearchContainer = document.createElement('div')
                .addClass("teva-selectbox-search")
            Instance.Container.appendChild(Instance.SearchContainer);

            if (Instance.PrimaryContainer.hasClass("teva-selectbox-multiline"))
                Instance.SearchContainer.addClass("teva-selectbox-multiline");

            Instance.$SearchContainer = $(Instance.SearchContainer).data("SelectBox", Instance);

            if (Instance.PrimaryContainer.hasClass("input-col-2")
                || Instance.PrimaryContainer.hasClass("input-col-4")
                || Instance.Input.hasClass("input-col-2")
                || Instance.Input.hasClass("input-col-4"))
                Instance.$SearchContainer.css("width", "243px");
            else if (Instance.PrimaryContainer.hasClass("input-col-6") || Instance.Input.hasClass("input-col-6"))
                Instance.$SearchContainer.css("width", "375px");

            if (Instance.Options.Inline || Instance.Options.AllowSearch)
                Instance.SearchContainer.addClass("teva-selectbox-search-inline");

            if (Instance.Options.AllowSearch) {
                Instance.SearchContainer.addClass("teva-selectbox-search-allowsearch")

                Instance.SearchTerms = document.createElement('div')
                    .addClass("teva-selectbox-search-terms");
                Instance.SearchContainer.appendChild(Instance.SearchTerms);

                Instance.SearchTermsInput = document.createElement('input')
                    .addClass("teva-selectbox-search-terms-input")
                Instance.SearchTerms.appendChild(Instance.SearchTermsInput);

                Instance.$SearchTermsInput = $(Instance.SearchTermsInput);
            }

            if (Instance.Options.AllowClear) {
                Instance.$SearchResultsRemove = $(document.createElement('div'))
                    .addClass("teva-selectbox-search-terms-clear")
                    .appendTo(Instance.SearchTerms);
            }

            Instance.SearchResultsContainer = document.createElement('div')
                .addClass("teva-selectbox-search-results-container");
            Instance.SearchContainer.appendChild(Instance.SearchResultsContainer);
            Instance.$SearchResultsContainer = $(Instance.SearchResultsContainer);

            var AdditionalSearchResultsContainer = document.createElement('div')
                .addClass("teva-selectbox-search-results-container-additional");
            Instance.SearchResultsContainer.appendChild(AdditionalSearchResultsContainer);

            Instance.SearchResults = document.createElement('div')
                .addClass("teva-selectbox-search-results", "sumit-fade-bottom");
            AdditionalSearchResultsContainer.appendChild(Instance.SearchResults);
            Instance.$SearchResults = $(Instance.SearchResults);

            Instance.SearchResultsEmpty = document.createElement('div')
                .addClass("teva-selectbox-search-results-empty");
            Instance.SearchResultsEmpty.innerHTML = Instance.Options.EmptyItemContents == null ? Teva.Resources.GetString("SelectBox", "NoResultsFound") : Instance.Options.EmptyItemContents(Instance.$SearchTermsInput.val());
            Instance.SearchResults.appendChild(Instance.SearchResultsEmpty);
            Instance.$SearchResultsEmpty = $(Instance.SearchResultsEmpty);

            Instance.SearchResultsLoading = document.createElement('div')
                .addClass("teva-selectbox-search-results-searching");
            Instance.SearchResultsLoading.innerText = Teva.Resources.GetString("SelectBox", "Searching");
            Instance.SearchResults.appendChild(Instance.SearchResultsLoading);
            Instance.$SearchResultsLoading = $(Instance.SearchResultsLoading);

            if (Instance.Options.EmptyItemClick != null)
                Instance.SearchResultsEmpty.addClass("teva-selectbox-search-results-result");

            if (Instance.Options.MinimumLength != null) {
                Instance.SearchResultsMinimum = document.createElement('div')
                    .addClass("teva-selectbox-search-results-minimum");
                Instance.SearchResultsMinimum.innerText = Teva.Resources.GetString("SelectBox", "TextTooShort");
                Instance.SearchResults.appendChild(Instance.SearchResultsMinimum);
                Instance.$SearchResultsMinimum = $(Instance.SearchResultsMinimum);
            }

            if (Instance.Options.FooterCreateText) {
                var $Create = $
                    (document.createElement('div')
                        .addClass("teva-selectbox-search-results-result", "teva-selectbox-search-results-result-create")
                    )
                    .html("<span class=\"icon-sumit-plus\"></span> " + Instance.Options.FooterCreateText)
                Instance.SearchResults.addClass("teva-selectbox-search-results-nobottompadding");
                Instance.SearchResultsContainer.appendChild($Create[0]);
            }

            Instance.$PrimaryContainer.insertBefore(Instance.$Input);

            if (Instance.Options.EmptyItemAlwaysVisible)
                Instance.$SearchResultsEmpty.show();
        }
        public static StaticBindEvents(): void {
            $(document)
                .on("click", ".teva-selectbox-label", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Event.which != 1 && Event.which !== undefined)
                        return false;
                    if (Instance.$Label.parents().filter(function () { return $(this).data("sortable-thresholdpassed") }).length > 0)
                        return false;
                    if (Instance.Options.CtrlClickEvent != null && Navigation.IsNewWindowEvent(Event)) {
                        var CtrlResult = Instance.Options.CtrlClickEvent(Instance.SelectedValue, Instance.SelectedData);
                        if (CtrlResult == false)
                            return false;
                    }
                    if (Instance.IsDisabled())
                        return false;

                    if (Instance.$SearchContainer.is(":visible"))
                        Instance.HideResults(true);
                    else {
                        $(document).trigger("click.SelectBox").trigger('click.datepicker-hide');
                        if (Instance.Options.AlternateShowMethod != null) {
                            if (Instance.Options.AlternateShowMethod())
                                return true;
                        }

                        Instance.ShowResults();
                    }
                    Event.preventDefault();
                    Event.stopPropagation();
                    Event.stopImmediatePropagation();
                    return false;
                })
                .on("keydown", ".teva-selectbox-label", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Instance.IsDisabled())
                        return true;
                    if (Instance.Options.AlternateShowMethod != null && Instance.Options.AlternateShowMethod())
                        return true;

                    if (Instance.PrimaryContainer.hasClass("teva-selectbox-container-open"))
                        Instance.Keyup_Results(Event.key, false);
                    else if (Event.key == "Enter") {
                        if (Instance.Options.CustomEnterKeyEvent != null) {
                            Instance.Options.CustomEnterKeyEvent(Event);
                            return false;
                        }
                        Instance.SkipKeyupEnterEvent = true;
                        Instance.ShowResults();
                    }
                    else if (Event.key == "ArrowDown" || Event.key == "ArrowUp")
                        Instance.ShowResults();
                    else if (Event.key == "Delete" || Event.key == "Backspace")
                        Instance.ClearValue();
                    else
                        return true;

                    Event.preventDefault();
                    Event.stopPropagation();
                    Event.stopImmediatePropagation();
                    return false;
                })
                .on("keypress", ".teva-selectbox-label", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Instance.IsDisabled())
                        return true;

                    if (Instance.Options.AllowSearch)
                        Instance.ShowResults(String.fromCharCode(Event.charCode));
                    else
                        Instance.ShowResults();

                    Event.preventDefault();
                    Event.stopPropagation();
                    Event.stopImmediatePropagation();
                    return false;
                })
                .on("focusin", ".teva-selectbox-label", function () {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    Instance.$Container.closest(".sumit-field").addClass("sumit-field-active");
                    Instance.PrimaryContainer.addClass("teva-selectbox-container-focus");
                })
                .on("focusout", ".teva-selectbox-label", function () {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Instance == null)
                        return;
                    if (!Instance.PrimaryContainer.hasClass("teva-selectbox-container-open"))
                        Instance.$Container.closest(".sumit-field").removeClass("sumit-field-active");
                    Instance.PrimaryContainer.removeClass("teva-selectbox-container-focus");
                })
                .on("keydown", ".teva-selectbox-search-terms-input", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (!Instance.Options.AllowSearch)
                        return true;
                    if (Event.key == "ArrowDown" || Event.key == "ArrowUp") {
                        Instance.Keyup_Results(Event.key, false)
                        Event.preventDefault();
                        Event.stopPropagation();
                        return false;
                    }
                    else if (Event.key == "Tab") {
                        Instance.Keyup_Results(Event.key, false);
                        if (Instance.Options.CustomEnterKeyEvent != null) {
                            Event.preventDefault();
                            Event.stopPropagation();
                            return false;
                        }
                    }
                    else if (Event.key == "Enter") {
                        Event.preventDefault();
                        Event.stopPropagation();
                        return false;
                    }
                })
                //.on("input", ".teva-selectbox-search-terms-input", function (Event) {
                //    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                //    Instance.RefreshResults(Instance.$SearchTermsInput.val());
                //})
                .on("keyup", ".teva-selectbox-search-terms-input", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (!Instance.Options.AllowSearch)
                        return true;
                    if (Event.key == "ArrowDown" || Event.key == "ArrowUp" || (Event.key == "Enter" && Instance.SkipKeyupEnterEvent)) {
                        Instance.SkipKeyupEnterEvent = false;
                        Event.preventDefault();
                        Event.stopPropagation();
                        return false;
                    }

                    if (!Instance.Options.AllowManualValues && Event.key != "Enter" && Event.key != "Tab" && Event.key != "Escape")
                        Instance.ClearValue();
                    if (Instance.Keyup_Results(Event.key, true))
                        Instance.RefreshResults(Instance.$SearchTermsInput.val());
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                })
                .on("click", ".teva-selectbox-search-results-empty", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Instance.Options.EmptyItemClick == null)
                        return true;

                    if (Instance.Options.EmptyItemClick(Instance))
                        Instance.HideResults();
                    Event.preventDefault();
                    Event.stopPropagation();
                    Event.stopImmediatePropagation();
                    return false;
                })
                .on("mouseenter", ".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-result-parent):not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-empty)", function () {
                    this.addClass("teva-selectbox-search-results-result-hover");
                })
                .on("mouseleave", ".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-result-parent):not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-empty)", function () {
                    this.removeClass("teva-selectbox-search-results-result-hover");
                })
                .on("click", ".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-result-parent):not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-empty)", function (Event) {
                    var $Result = $(this);
                    var Instance = <SelectBox>$Result.closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (Instance == null)
                        return;

                    if (Instance.Options.CtrlClickEvent != null && Navigation.IsNewWindowEvent(Event)) {
                        var Value;
                        if ($Result.hasClass("teva-selectbox-search-results-empty"))
                            Value = null;
                        else
                            Value = $Result.data("SelectBox-id");
                        if (Instance.Options.CtrlClickEvent(Value, $Result.data("SelectBox-data")) == false) {
                            Event.preventDefault();
                            Event.stopPropagation();
                            return;
                        }
                    }

                    Instance.SelectResult($Result);
                    Event.preventDefault();
                    Event.stopPropagation();
                    Event.stopImmediatePropagation();
                })
                .on("click", ".teva-selectbox-search-terms-clear", function (Event) {
                    var Instance = <SelectBox>$(this).closest(".teva-selectbox-container, .teva-selectbox-search").data("SelectBox");
                    if (!Instance.Options.AllowClear)
                        return true;

                    Instance.ClearValue();

                    Instance.HideResults(true);

                    Event.preventDefault();
                    Event.stopPropagation();
                });
        }

        private Keyup_Results(Key, RefreshResultsOnEmpty): boolean {
            var Instance = this;
            if (Key == "ArrowUp" || Key == "ArrowDown") {
                var $Active = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-hover");
                if ($Active.length == 0)
                    $Active = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-active");
                var $ElementToFocus = null;
                if (Key == "ArrowUp") {
                    $ElementToFocus = $Active.prevAll(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-result-parent):first");
                    if ($ElementToFocus.length == 0)
                        $ElementToFocus = Instance.$SearchResults.find(".teva-selectbox-search-results-result:last");
                }
                else { //if (Key == "ArrowDown")
                    if ($Active.length == 0)
                        $ElementToFocus = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result:first");
                    else 
                        $ElementToFocus = $Active.nextAll(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-result-parent):first");
                    if ($ElementToFocus.length == 0)
                        $ElementToFocus = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result:last");
                }

                if ($ElementToFocus.length != 0) {
                    $Active.removeClass("teva-selectbox-search-results-result-hover");
                    $ElementToFocus.addClass("teva-selectbox-search-results-result-hover");
                    Instance.FocusOnActiveResult();
                }
                return false;
            }
            else if (Key == "Enter" || Key == "Tab") {
                if (Key == "Enter" || (Key == "Tab" && Instance.Options.SelectOnTab)) {
                    var $Active = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-hover");
                    if ($Active.length == 0)
                        $Active = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-active");
                    var ActiveIsEmpty = $Active.hasClass("teva-selectbox-search-results-empty") || $Active.hasClass("teva-selectbox-search-results-result-create");
                    if (ActiveIsEmpty || $Active.length == 0) {
                        if ((Instance.$SearchTermsInput == null || Instance.$SearchTermsInput.val() == "") && Instance.PreviousText != "") {
                            if (ActiveIsEmpty && Instance.Options.EmptyItemClick(Instance)) {
                            }
                            else
                                Instance.ClearValue();
                            Instance.HideResults(true);
                        }
                        else if (Instance.Options.AllowManualValues) {
                            if (Instance.SelectedText != Instance.$SearchTermsInput.val())
                                Instance.SetValue(Instance.$SearchTermsInput.val(), Instance.$SearchTermsInput.val(), null, false);
                            Instance.HideResults(true);
                        }
                        else if ($Active.length > 0)
                            Instance.SelectResult($Active);
                        else
                            Instance.HideResults(true);
                    }
                    /*else if (Instance.$SearchTermsInput != null && Instance.$SearchTermsInput.val() != "" && Active.hasClass("teva-selectbox-search-results-result-remove")) {
                        if (Instance.Options.AllowManualValues) {
                            if (Instance.SelectedText != Instance.$SearchTermsInput.val())
                                Instance.SetValue(Instance.$SearchTermsInput.val(), Instance.$SearchTermsInput.val(), null, false);
                        }
                        else
                            Instance.ClearValue();
                        Instance.HideResults(true);
                    }*/
                    else
                        Instance.SelectResult($Active);
                }
                else
                    Instance.HideResults(true);

                if ((Key == "Enter" || Key == "Tab") && Instance.Options.CustomEnterKeyEvent != null) {
                    Instance.Options.CustomEnterKeyEvent(window.event);
                    return false;
                }
                if (Key == "Enter")
                    return false;

                return true;
            }
            else if (Key == "Escape") {
                Instance.HideResults(true);
                return false;
            }
            else if ((Key == "Delete" || Key == "Backspace") && Instance.$SearchTermsInput.val().length == 0) {
                if (RefreshResultsOnEmpty)
                    Instance.RefreshResults("");
                Instance.ClearValue();
                return false;
            }
            return true;
        }

        private SelectResult($Result): void {
            var Instance = this;
            if ($Result.hasClass("teva-selectbox-search-results-result-create"))
                Instance.Options.FooterCreate(Instance);
            else if ($Result.hasClass("teva-selectbox-search-results-empty"))
                Instance.Options.EmptyItemClick(Instance);
            else {
                var Value = $Result.data("SelectBox-id");
                var Text = $Result.data("SelectBox-text");
                Instance.SetValue(Value, Text, $Result.data("SelectBox-data"), false);
            }
            Instance.HideResults(true);
        }
        private AppendResultItem(Item) {
            var Instance = this;
            var Div = document.createElement('div')
                .addClass("teva-selectbox-search-results-result");
            var $Div = $(Div)
                .addClass(Item.cssClass)
                .data("SelectBox-id", Item.id)
                .data("SelectBox-text", Item.text)
                .data("SelectBox-data", Item.data);
            Instance.SearchResults.appendChild(Div);

            if (Instance.Options.FormatResultItem != null)
                $Div.append(Instance.Options.FormatResultItem(Item));
            else
                Instance.SetTextHTML(Div, Item.text, Item.data);
            if (Item.children)
                Div.addClass("teva-selectbox-search-results-result-parent");
            else if (Item.disabled)
                Div.addClass("teva-selectbox-search-results-result-disabled");

            if (Item.children != null)
                for (var i = 0; i < Item.children.length; i++)
                    Instance.AppendResultItem(Item.children[i]);
        }
        private FocusOnActiveResult() {
            var Instance = this;
            var $Result = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-hover");
            if ($Result.length == 0)
                $Result = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-active");
            if ($Result.length == 0)
                return;

            var Position_Top = Instance.$SearchResults.scrollTop() + $Result.position().top;
            var Position_Bottom = Position_Top + $Result.outerHeight();
            var Visible_Top = Instance.$SearchResults.scrollTop();
            var Visible_Bottom = Visible_Top + Instance.$SearchResults.height();

            if (Visible_Bottom < Position_Bottom)
                Instance.$SearchResults.scrollTop(Position_Top - ($Result.outerHeight() * 2));
            else if (Position_Top < Visible_Top)
                Instance.$SearchResults.scrollTop(Position_Top);
        }
        private FocusByInput() {
            var Instance = this;
            var Value = Instance.$Input.val();
            Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result-active").removeClass("teva-selectbox-search-results-result-active");
            var $Result = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result").filter(function () { return $(this).data("SelectBox-id") == Value; });
            if ($Result.length == 0) {
                if (Value != '' && Value != '0')
                    return;

                $Result = Instance.$SearchResultsContainer.find(".teva-selectbox-search-results-result:visible:not(.teva-selectbox-search-results-result-disabled):not(.teva-selectbox-search-results-result-parent)");
            }
            else
                $Result.first().addClass("teva-selectbox-search-results-result-active");
            if ($Result.length > 1 && Instance.Options.EmptyItemAlwaysVisible && Instance.$SearchTermsInput.val() != "")// && Instance.SearchTermsInput.val() == $(Result[1]).text())
                $Result = $($Result[1]);
            Instance.$SearchResultsContainer.find('.teva-selectbox-search-results-result-hover').removeClass('teva-selectbox-search-results-result-hover');
            $Result.first().addClass("teva-selectbox-search-results-result-hover");
            Instance.FocusOnActiveResult();
        }
        private RefreshResultsData(Terms, PageIndex, Data) {
            var Instance = this;
            if (PageIndex == 0)
                Instance.$SearchResults.find(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-empty)").remove();
            if (Data.results.length == 0 || Instance.Options.EmptyItemAlwaysVisible) {
                Instance.$SearchResultsEmpty.show();
                if (!Instance.Options.EmptyItemAlwaysVisible)
                    Instance.SearchResultsEmpty.innerHTML = Instance.Options.EmptyItemContents == null ? "לא נמצאו תוצאות" : Instance.Options.EmptyItemContents(Instance.$SearchTermsInput.val());
            }
            else
                Instance.$SearchResultsEmpty.hide();
            if (Instance.Options.AllowClear)
                Instance.$SearchResultsRemove.toggle(Instance.SelectedValue != Instance.Options.EmptyValue);

            for (var i = 0; i < Data.results.length; i++)
                Instance.AppendResultItem(Data.results[i]);

            Instance.$SearchResults.find(".teva-selectbox-search-results-result").each(function () {
                var $Div = $(this);
                if ($Div.prop("scrollWidth") > $Div.outerWidth() + 1)
                    $Div[0].setAttribute("title", $Div.data("SelectBox-text"));
            });
            if (Instance.Options.OnRefreshResultsData)
                Instance.Options.OnRefreshResultsData();
            Instance.$SearchResults.trigger("scroll.sumit-fade");
        }
        private EnableScroll() {
            var Instance = this;
            if (SelectBox.VisibleMobileInstance == Instance) {
                Instance.$PrimaryContainer.off("scroll.SelectBox").on("scroll.SelectBox", function () {
                    var CurrentScroll = Instance.$PrimaryContainer.scrollTop();
                    var MaximumScroll = Instance.PrimaryContainer.scrollHeight - Instance.$PrimaryContainer.outerHeight();
                    if (CurrentScroll >= MaximumScroll - 10)
                        Instance.LoadResults(Instance.VisibleTerms, Instance.VisiblePageIndex + 1);
                });
            }
            else {
                Instance.$SearchResults.off("scroll.SelectBox").on("scroll.SelectBox", function () {
                    var CurrentScroll = Instance.$SearchResults.scrollTop();
                    var MaximumScroll = Instance.SearchResults.scrollHeight - Instance.$SearchResults.outerHeight();
                    if (CurrentScroll >= MaximumScroll - 10)
                        Instance.LoadResults(Instance.VisibleTerms, Instance.VisiblePageIndex + 1);
                });
            }
        }
        private DisableScroll() {
            this.$SearchResults.off("scroll.SelectBox");
        }
        private ShowLoading(PageIndex) {
            this.SearchContainer.addClass("teva-selectbox-search-loading");
            if (PageIndex == 0)
                this.$SearchResultsLoading.show();
        }
        private HideLoading(IsFinal) {
            if (IsFinal || this.$SearchResults.children(".teva-selectbox-search-results-result").length > 0)
                this.$SearchResultsLoading.hide();
            if (IsFinal)
                this.SearchContainer.removeClass("teva-selectbox-search-loading");
        }

        private RefreshResults(Terms) {
            var Instance = this;
            if (Instance.VisibleTerms != null
                && Terms.indexOf(Instance.VisibleTerms) == 0
                && Instance.Options.EnableCaching
                && Instance.Options.EnableCachingPartialReduce
                && Instance.RequestThrottlePendingRequests.length == 0
                && Instance.RequestThrottleTimeout == null
                && Instance.VisibleTerms.length >= Instance.Options.MinimumLength
                && Instance.$SearchResults.find(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-empty)").length == 0) {
                Instance.VisibleTerms = Terms;
                Instance.SearchResultsEmpty.innerHTML = Instance.Options.EmptyItemContents == null ? "לא נמצאו תוצאות" : Instance.Options.EmptyItemContents(Instance.$SearchTermsInput.val());
                return;
            }
            else if (Terms == null || Terms == "")
                Instance.SearchResultsEmpty.innerHTML = Instance.Options.EmptyItemContents == null ? "לא נמצאו תוצאות" : Instance.Options.EmptyItemContents(Terms);

            if (Instance.Options.AllowClear)
                Instance.$SearchResultsRemove.toggle(Instance.SelectedValue != Instance.Options.EmptyValue);

            if (Instance.SelectConvertedResults == null) {
                if (Instance.VisibleTerms == Terms
                    && Instance.RequestThrottlePendingRequests.length == 0
                    && Instance.RequestThrottleTimeout == null) {
                    Instance.FocusByInput();
                    return;
                }
            }

            if (Instance.Options.MinimumLength != null) {
                if (Instance.Options.MinimumLength > Terms.length) {
                    Instance.$SearchResults.find(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-empty)").remove();
                    if (Instance.SearchResultsEmpty != null && !Instance.Options.EmptyItemAlwaysVisible)
                        Instance.$SearchResultsEmpty.hide();
                    Instance.$SearchResultsMinimum.show();
                    Instance.VisibleTerms = null;
                    return;
                }
                Instance.$SearchResultsMinimum.hide();
            }

            if (!Instance.Options.EmptyItemAlwaysVisible)
                Instance.$SearchResultsEmpty.hide();
            Instance.$SearchResults.find(".teva-selectbox-search-results-result:not(.teva-selectbox-search-results-empty)").remove();
            Instance.LoadResults(Terms, 0);
        }
        private LoadResults(Terms, PageIndex) {
            var Instance = this;
            if (Instance.Options.EmptyItemAlwaysVisible)
                Instance.SearchResultsEmpty.innerHTML = Instance.Options.EmptyItemContents == null ? "לא נמצאו תוצאות" : Instance.Options.EmptyItemContents(Terms);
            if (Instance.QueryMethod == null)
                return;

            Instance.ShowLoading(PageIndex);
            Instance.ThrottleQuery(Terms, PageIndex, function (Data, LoadedTerms, LoadedPageIndex) {
                var RequestIndex = -1;
                for (var i = 0; i < Instance.RequestThrottlePendingRequests.length; i++)
                    if (Instance.RequestThrottlePendingRequests[i].Terms == Terms && Instance.RequestThrottlePendingRequests[i].PageIndex == PageIndex)
                        RequestIndex = i;
                if (RequestIndex == -1)
                    return;

                Instance.RequestThrottlePendingRequests.splice(0, RequestIndex + 1);
                if (Data.more)
                    Instance.EnableScroll();
                else
                    Instance.DisableScroll();
                Instance.RefreshResultsData(LoadedTerms, LoadedPageIndex, Data);
                Instance.VisiblePageIndex = PageIndex;
                Instance.VisibleTerms = LoadedTerms;
                Instance.HideLoading(Instance.RequestThrottlePendingRequests.length == 0);
                Instance.$SearchResults.trigger("scroll.sumit-fade");
                if (PageIndex == 0)
                    Instance.FocusByInput();
            });
        }
        private ThrottleQuery(Terms, PageIndex, Callback): void {
            var Instance = this;

            Instance.RequestThrottleAdd(Terms, PageIndex, function () {
                if (Instance.Options.EnableCaching) {
                    if (Instance.Cache == null)
                        Instance.Cache = [];
                    var CachedData = Instance.Cache[Terms + "////" + PageIndex];

                    if (CachedData) {
                        Callback(CachedData, Terms, PageIndex);
                        return;
                    }

                    if (Instance.Options.EnableCachingPartialReduce) {
                        var PartialTerm = Terms;
                        while (PartialTerm.length > 0) {
                            PartialTerm = PartialTerm.substring(0, PartialTerm.length - 1);
                            CachedData = Instance.Cache[PartialTerm + "////" + PageIndex];
                            if (CachedData) {
                                if (CachedData.more == true)
                                    break;

                                var ToReturn = {
                                    more: false,
                                    results: SelectBox.FilterResults(CachedData.results, Terms, null)
                                };

                                Callback(ToReturn, Terms, PageIndex);
                                return;
                            }
                        }
                    }
                }

                Instance.QueryMethod(Terms, null, PageIndex, function (Data) {
                    if (Instance.Options.EnableCaching)
                        Instance.Cache[Terms + "////" + PageIndex] = Data;
                    Callback(Data, Terms, PageIndex);
                });
            });
        }
        static FilterResults(Results, Query, QueryByID) {
            if (Query.length == 0 && QueryByID == null)
                return Results;

            Query = Query.toLowerCase();
            var ToReturn = new Array();
            for (var i = 0; i < Results.length; i++) {
                var Result = Results[i];
                if (QueryByID) {
                    if (Result.children) {
                        var FilteredChildren = [];
                        for (var j = 0; j < Result.children.length; j++) {
                            var Child = Result.children[j];
                            if (!Child.disabled && Child.id == QueryByID)
                                FilteredChildren.push(Child);
                        }
                        if (FilteredChildren.length > 0) {
                            ToReturn.push({
                                text: Result.text,
                                cssClass: Result.cssClass,
                                children: FilteredChildren
                            });
                        }
                    }
                    else if (Result.id == QueryByID)
                        ToReturn.push(Result);
                }
                else {
                    if (Result.children != null && Result.children.length > 0) {
                        var FilteredChildren = [];
                        for (var j = 0; j < Result.children.length; j++) {
                            var Child = Result.children[j];
                            if (!Child.disabled && Child.text.toLowerCase().indexOf(Query) != -1)
                                FilteredChildren.push(Child);
                        }
                        if (FilteredChildren.length > 0) {
                            ToReturn.push({
                                text: Result.text,
                                cssClass: Result.cssClass,
                                children: FilteredChildren
                            });
                        }
                    }
                    else {
                        if (Result.text.toLowerCase().indexOf(Query) != -1)
                            ToReturn.push(Result);
                    }
                }
            }
            return ToReturn;
        }

        private RequestThrottleNextRequest;
        private RequestThrottleTimeout;
        private RequestThrottlePendingRequests = new Array();
        private RequestThrottleAdd(Terms, PageIndex, NewRequest) {
            var Instance = this;
            Instance.RequestThrottleNextRequest = { Terms, PageIndex, NewRequest };
            if (Instance.RequestThrottleTimeout != null)
                return;

            Instance.RequestThrottleTimeout = setTimeout(function () {
                Instance.RequestThrottleTimeout = null;
                var NextRequest = Instance.RequestThrottleNextRequest;
                Instance.RequestThrottleNextRequest = null;
                Instance.RequestThrottlePendingRequests.push(NextRequest);
                NextRequest.NewRequest();
            }, Instance.Options.ThrottleTimeout);
        }
        static VisibleMobileInstance: SelectBox;
        static NextID: number = 1;

        public $Input;
        public Input;

        public PrimaryContainer;
        public $PrimaryContainer;

        public Container;
        public $Container;

        public SearchContainer;
        public $SearchContainer;

        public SearchResultsContainer;
        public $SearchResultsContainer;

        public SelectedValue: string;
        public PreviousValue: string;
        public SelectedText: string;
        public SelectedData: any;
        public PreviousText: string;
        public ChangeEventFromInit: boolean;

        private $Clone;

        public Label;
        public $Label;

        public LabelText;
        public $LabelText;

        private SearchTerms;

        public SearchTermsInput;
        public $SearchTermsInput;

        public SearchResults;
        public $SearchResults;

        private SearchResultsLoading;
        private $SearchResultsLoading;

        private SearchResultsEmpty;
        private $SearchResultsEmpty;

        private SearchResultsMinimum;
        private $SearchResultsMinimum;

        private $SearchResultsRemove;

        public VisibleTerms: string;
        private VisiblePageIndex: number;
        private Options: SelectBoxOptions;
        private QueryMethod: SelectBoxQueryInterface;
        private Cache;
        private Disabled: boolean;
        private ContainerCssClasses;
        private OnChange;
        private SkipKeyupEnterEvent: boolean;
        public SelectConvertedResults;
    }
}

(function ($) {
    // eventType - "click", "mouseover" etc.
    // destination - either jQuery object, dom element or selector

    (<any>$.fn).copyEventTo = function (eventType, destination) {
        var events = [];
        this.each(function () {
            var allEvents = (<any>jQuery)._data(this, "events");
            if (typeof allEvents === "object") {
                var thoseEvents = allEvents[eventType];
                if (typeof thoseEvents === "object") {
                    for (var i = 0; i < thoseEvents.length; i++)
                        events.push(allEvents[eventType][i].handler);
                }
            }
        });
        if (typeof destination === "string")
            destination = $(destination);
        else if (typeof destination === "object") {
            if (typeof destination.tagName === "string")
                destination = $(destination);
        }
        destination.each(function () {
            for (var i = 0; i < events.length; i++)
                destination.on(eventType, events[i]);
        });
        return this;
    }
})(jQuery);

$(document).on("Teva.Init", function () {
    Teva.SelectBox.StaticBindEvents();
});